import { render } from "./CompanyComponent.vue?vue&type=template&id=f549911c&ts=true"
import script from "./Company.service?vue&type=script&lang=ts&external"
export * from "./Company.service?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__